<template>
    <div class="topbar-index fixed top-0 w-full bg-a-egg-f5ebdc">
        <CookieBanner></CookieBanner>
        <DesktopTopbar></DesktopTopbar>
        <MobileTopbar></MobileTopbar>
    </div>
</template>
<script>
import DesktopTopbar from './component/DesktopTopbar.vue'
import MobileTopbar from './component/MobileTopbar.vue'
//compenents
import CookieBanner from './component/CookieBanner.vue';

export default {
    components: {
        DesktopTopbar,
        MobileTopbar,
        CookieBanner,
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .topbar-index {
        z-index: $zindex-fixed;
    }
</style>
